<template>
    <div>
        <el-form-item label="">
            <el-tooltip placement="top" effect="light">
                <div slot="content">
                    <img src="/static/help/mobileapp.png" alt="">
                </div>
                <el-button type="info" size="mini">
                    <i class="fa fa-question-circle"></i> Pomocnicze informacje dotyczące grafik
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item label="Kolor tła"
                      :error="errors['bg_color']">
            <el-color-picker v-model="form.bg_color"/>
        </el-form-item>
        <el-form-item label="Treść"
                      :error="errors[addLanguageSuffix('content')]">
            <wyswig-input v-model="form[addLanguageSuffix('content')]"/>
        </el-form-item>
        <el-form-item label="Link iOS">
            <link-component v-model="form.ios_link"
                            :errors="errors.ios_link">
            </link-component>
        </el-form-item>
        <el-form-item label="Link Android">
            <link-component v-model="form.android_link"
                            :errors="errors.android_link">
            </link-component>
        </el-form-item>
        <el-form-item label="Lewe tło"
                      :error="errors['left_image']">
            <image-input-component v-model="form.left_image"/>
        </el-form-item>
        <el-form-item label="Prawe tło"
                      :error="errors['right_image']">
            <image-input-component v-model="form.right_image"/>
        </el-form-item>
        <el-form-item label="Zdjęcie telefonu"
                      :error="errors['phone_image']">
            <image-input-component v-model="form.phone_image"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// MobileAppWidget.vue?56e4480a